import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../init/getData';

import { Modal, Col, Form, Row, DropdownButton, Dropdown, InputGroup } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs, message, Card, theme } from 'antd';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../components/loader/loader';
import LoadTransferJv from './functions/loadTransferJv';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../components/formatters/numberFormatter';


import InvoiceInfo from './steps/invoiceInfo';
import InvoiceCart from './steps/invoiceCart';
import InvoiceJv from '../../components/journalVoucher/invoiceJv';

const TransferForm = (props) => {

    const { api, userData, settingData, accountData, defaultCurrency, selectedCompany,
        productData, refData, branchData, projectData, selectedYear,
        currencyData } = useContext(DataContext);


    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);
    const companyId = selectedCompany.id;
    const yearId = selectedYear.id;

    const { showModal, toggleModal, table, title, refreshTable, isOrder, idRow } = props;
    const [loadingEffect, setLoadingEffect] = useState(false);
    const [validated, setValidated] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const [journalVoucher, setJournalVoucher] = useState({});
    const [cart, setCart] = useState([])
    const [transactions, setTransactions] = useState([])


    const totalCost = cart.reduce((sum, currentItem) => sum + parseFloat(currentItem?.cost * currentItem?.netQuantity), 0);

    const today = new Date().toISOString().split('T')[0];

    const selectedCurrency = currencyData?.find(option => option.id === journalVoucher.currencyId);

    const cartItem = {
        accountId: '',
        index: 0,

        quantity: 1,
        netQuantity: 1,

        cost: 0,
        netCost: 0,

        details: '',

        unitName: '',
        unitQuantity: '',

        productId: '',
    };


    // idRow Change
    useEffect(() => {

        if (!isLoading) {

            setCart(idRow?.cart || [cartItem])

            setTransactions(idRow?.transactions || [])

            setJournalVoucher(
                {
                    createdBy: createdBy,
                    companyId: companyId,
                    yearId: yearId,
                    accountId: idRow?.accountId || null,
                    refNumber: idRow?.refNumber || '',
                    date: idRow?.date || today,
                    type: 'StockTransfer',
                    details: idRow?.details || '',
                    isDebit: idRow?.isDebit || true,
                    isOrder: idRow?.isOrder || isOrder,
                    warehouseId: idRow?.warehouseId || null,
                    transferWarehouseId: idRow?.transferWarehouseId || null,
                    projectId: idRow?.projectId || null,
                    branchId: idRow?.branchId || null,
                    currencyId: idRow?.currencyId || defaultCurrency?.id,
                    rate: idRow?.rate || defaultCurrency?.rate,
                }
            )
        }
    }, [isLoading, idRow]);


    // change totalDebit and totalCredit
    useEffect(() => {

        const totalDebit = totalCost;
        const totalCredit = totalCost;

        setJournalVoucher((prev) => ({
            ...prev,
            totalDebit: totalDebit,
            totalCredit: totalCredit,
        }));

    }, [totalCost]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const dataArray = ['auxAccount', 'warehouse', 'branch', 'project', 'currency', 'product', 'setting']
                await refData(dataArray, companyId);
                setIsLoading(false);
            } catch (error) {
                console.error('Error refreshing data Contact Support');
            }
        };
        if (showModal) {
            fetchData();
        }
    }, [showModal]);



    const handleSubmit = async (e) => {
        e.preventDefault();


        const form = document.getElementById('form');

        if (form.checkValidity() === false) {
            return;
        }

        if (transactions.length < 2) {
            toast.error('you need at least 2 transactions')
            return;
        }


        setLoadingEffect(true);


        const data = {
            jvId: idRow?.id,
            transactions,
            journalVoucher,
            cart,
            charges: [],
        }

        const operation = idRow ? 'edit' : 'add'
        try {
            let res = await api.post(`journalVoucher/${operation}`, data);

            if (res.data.status) {
                toast.success(res.data.message);
                closeModal();
            } else {
                toast.error(res.data.message);
            }
        } catch (error) {
            toast.error("Failed Contact Support");
        } finally {
            setLoadingEffect(false);
            setValidated(false);
        }
    }

    const closeModal = () => {
        toggleModal();
        setValidated(false);
        const form = document.getElementById('form');
        form.reset();
        setCart([cartItem]);
        setTransactions([]);
        refreshTable();
    }



    return (
        <>
            <Modal show={showModal} onHide={toggleModal} size={'xl'} backdrop="static">

                <Modal.Header style={{ background: "#23576a" }} closeButton>
                    <Modal.Title style={{ color: "white" }}>{idRow ? 'Edit ' : 'Add '}{title}</Modal.Title>
                </Modal.Header>

                <Form validated={validated} id={'form'} onSubmit={handleSubmit} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); } }} >
                    <Modal.Body className="custom-scrollbar" style={{ backgroundColor: '#f0f2f5', maxHeight: '75vh', overflowY: 'auto' }}>

                        <Row className="mb-4">
                            <Col>

                                <Card title="Details" bordered={false}>
                                    <InvoiceInfo
                                        journalVoucher={journalVoucher}
                                        setJournalVoucher={setJournalVoucher}
                                        validated={validated}
                                    />
                                </Card>
                            </Col>
                        </Row>

                        <Row className="mb-4">
                            <Col>
                                <Card title="Products" bordered={false}>
                                    <InvoiceCart
                                        cart={cart}
                                        setCart={setCart}
                                        cartItem={cartItem}
                                        validated={validated}
                                        journalVoucher={journalVoucher}
                                        selectedCurrency={selectedCurrency}
                                    />
                                </Card>
                            </Col>
                        </Row>

                        <Row className="mb-4">
                            <Col>
                                <Card title="Journal Voucher" bordered={false}>
                                    <InvoiceJv
                                        transactions={transactions}
                                        selectedCurrency={selectedCurrency}
                                    />
                                </Card>
                            </Col>
                        </Row>

                    </Modal.Body>

                    <Modal.Footer>
                        <Button type="primary" loading={loadingEffect} htmlType="submit"
                            onClick={() => setValidated(true)}
                            style={{ marginLeft: '10px', backgroundColor: '#1d7790' }}>Save</Button>
                    </Modal.Footer>

                </Form>
            </Modal >

            <LoadTransferJv
                setTransactions={setTransactions}
                totalCost={totalCost}
                cart={cart}
                journalVoucher={journalVoucher}
                selectedCurrency={selectedCurrency}
            />
        </>
    )
}


export default TransferForm;